<script>
  import { apiServer } from "../config.js";
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import { fade } from "svelte/transition";
  import Load from "../components/Load.svelte";
  import Modal from "../components/Modal.svelte";
  import ProfileCard from "../components/ProfileCard.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import Title from "../components/Title.svelte";
  import AXHR from "../components/js/axhr.js";

  import format from "number-format.js";
  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });
  let alert = [];
  let shake = "shake";

  let loading = false;
  let success;
  $: success = false;
  async function handleSubmit(event) {
    loading = true;
    let payload;
    let method = "post";
    let apiEndPoint = apiServer + "/points";
    payload = {
      amount: String(amount),
      description: "Topup by user",
    };

    shake = "";
    var data = payload;

    var config = {
      method: method,
      url: apiEndPoint,
      headers: {
        Authorization: "Bearer " + sessions.token,
      },
      data: data,
    };

    AXHR(config)
      .then(function (response) {
        alert = [
          ...alert,
          {
            title: "Mikhub",
            message: response.data.message,
            color: "green",
          },
        ];
        success = response.data;
        loadData(sessions.api + "/points", sessions.token, false);
        loading = false;
      })
      .catch(function (error) {
        success = false;
        loading = false;

        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/splash");
          loadingLine = false;
        } else {
          shake = "shake";
          alert = [
            ...alert,
            {
              title: "Oops...",
              message: error.response.data.message,
              color: "yellow",
            },
          ];
        }
      });
  }

  let items = [];
  //navigation
  let navigation = [];
  $: if (sessions.loggedin == true) {
    if (sessions.user.firstName != undefined) {
      navigation["message"] =
        sessions.user.firstName + " " + sessions.user.lastName;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //SERVER LOAD
  $: topupAmount = [
    { price: 100000, amount: 100000, discount: false },
    { price: 150000, amount: 150000, discount: false },
    { price: 200000, amount: 200000, discount: false },
    { price: 250000, amount: 250000, discount: false },
    { price: 500000, amount: 500000, discount: false },
    { price: 1000000, amount: 1000000, discount: false },
  ];
  $: payMethod = [
    {
      type: "Bank Transfer",
      name: "BTPN",
      number: "90020378863",
      note: "A/n Ade Arwan Setiawan",
      instruction: "Bank Code Is 213",
    },
    {
      type: "E-wallet",
      name: "Jenius",
      number: "@AdeasRakITLabs",
      note: "A/n Ade Arwan Setiawan",
      instruction: "Make Payout to @AdeasRakITLabs with your jenius app",
    },
    {
      type: "E-wallet",
      name: "Dana",
      number: "088219624900",
      note: "A/n Ade Arwan Setiawan",
      instruction: "Send transfer with your Dana App",
    },
    {
      type: "Convention Store",
      name: "Alfamart",
      number: "088219624900",
      note: "A/n Ade Arwan Setiawan",
      instruction: "Topup Dana to Alfamart Cassier",
    },
  ];
  $: dataFiltered = [];
  function loadData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config)
      .then(function (response) {
        let res;
        res = response.data;
        if (filter !== false) {
          res = res.filter((el) => {
            return el[filter.name] !== filter.value;
          });
        } else {
          res = res;
        }
        dataFiltered = res;
      })
      .catch(function (error) {
        alert = [
          ...alert,
          {
            title: "Oops...",
            message: error.response.data.message,
            color: "yellow",
          },
        ];
      });
  }
  if (sessions) {
    loadData(sessions.api + "/points", sessions.token, false);
  }
  let amount = false;
  $: console.log(amount);
  let loadTable = false;
  setTimeout(() => {
    loadTable = true;
  }, 1000);
  import MakeSortable from "../components/MakeTable/MakeSortable.svelte";
  import SortHeader from "../components/MakeTable/SortHeader.svelte";
  let filter = "",
    imgsortIconCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" /></svg>',
    imgsortIconAscCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"></path></svg>',
    imgsortIconDescCss =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="inline w-3 h-3"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" /></svg>';
</script>

<svelte:head>
  <title>Mikhub - Points</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<Navigationbar
  backbtn="true"
  message={navigation["message"]}
  title="Back"
  align="center"
/>
<main
  transition:fade
  class="max-w-screen-xl px-2 pt-0 mx-auto mb-2 lg:pt-16 md:pt-16"
>
  {#if loading}
    <Load />
  {/if}
  <div class={shake}>
    <div class="w-full mx-auto mt-32 md:mt-16 lg:mt-16">
      {#if success}
        <div
          class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 md:w-2/4 lg:w-2/5"
        >
          <div class="w-full mx-auto mb-2">
            <div class="block p-5 py-10 bg-white rounded-lg shadow-md group">
              <p class="text-center">
                <b class="block mb-5 text-xl">Your points will be added soon!</b
                >Immediately make a payment then contact us to confirm payment

                <Modal backdropClose size="lg:w-4/6 w-full">
                  <div class="block my-5" slot="trigger" let:open>
                    <button
                      on:click={open}
                      class="w-full px-5 py-3 text-lg text-white bg-blue-500 rounded-md cursor-pointer"
                      >Pay Now</button
                    >
                  </div>
                  <div slot="header" class="text-center">
                    <h1 class="text-lg">Payment Channels</h1>
                  </div>
                  <div slot="content" class="h-auto" style="max-height:100%">
                    <p class="p-5 text-center">
                      Make a payment of <b
                        >{String(format("Rp#.##0,", success.amount))}</b
                      > to one of the channels below
                    </p>
                    <div class="flex flex-wrap h-auto pb-10">
                      {#if payMethod}
                        {#each payMethod as d, i}
                          <div for="topup-{i}" class="w-full lg:w-1/2 md:w-1/2">
                            <div
                              class="flex items-center justify-between px-4 py-3 m-2 text-left bg-white border border-gray-200 rounded-md hover:shadow-lg cursor-pointershadow-sm"
                            >
                              <div
                                class="w-4/5 text-base text-gray-800 lg:w-11/12 md:w-11/12"
                              >
                                <span class="text-sm">{d.type}</span><br />

                                <b class="text-sm">{d.name}</b><br />
                                <span
                                  class="w-full p-2 font-mono text-xl font-bold border-none rounded-md select-all"
                                  >{d.number}</span
                                ><br />
                                <span class="text-sm">{d.note}</span><br />
                                <span class="text-xs">{d.instruction}</span>
                              </div>
                              <div
                                class="items-center justify-end w-1/5 lg:w-1/12 md:1/12"
                              />
                            </div>
                          </div>
                        {:else}
                          <p
                            class="p-5 mx-5 mt-10 text-center bg-yellow-100 border-2 border-yellow-200 rounded-lg"
                          >
                            <b class="text-2xl"
                              >Oops...<br />Belum ada channel pembayaran untuk
                              saat ini</b
                            ><br />Mohon maaf, channel pembayaran saat ini
                            sedang dinonaktifkan, silahkan coba lagi nanti
                          </p>
                        {/each}
                      {/if}
                    </div>
                  </div>
                </Modal>
                <a
                  on:click={(success = false)}
                  href="/points"
                  class="block px-5 py-2 my-5 text-white bg-gray-600 rounded"
                  >Back</a
                >
              </p>
            </div>
          </div>
        </div>
      {:else}
        <div
          class="items-start block w-full gap-3 mx-auto my-5 lg:flex md:flex lg:my-0 "
        >
          <div
            class="flex flex-wrap items-center w-full mx-auto my-5 lg:w-2/3 md:w-full lg:my-0 "
          >
            <div class="w-full mx-auto mb-2">
              <ProfileCard />
              <div
                class="block px-4 py-3 mt-5 bg-white rounded-lg shadow-md group"
              >
                <Title
                  title="Topup Your Points"
                  subtitle="Add Deposit To Your Points"
                  tipe="3"
                  href="./"
                />

                <div class="flex flex-wrap h-auto pb-10">
                  {#if topupAmount}
                    {#each topupAmount as d, i}
                      <label for="topup-{i}" class="w-1/2 lg:w-1/3 md:w-1/2">
                        <div
                          class="flex items-center justify-between px-2 py-2 m-2 text-left bg-white border border-gray-200 rounded-md hover:shadow-lg cursor-pointershadow-sm"
                        >
                          <div
                            class="w-4/5 text-base text-gray-800 lg:w-11/12 md:w-11/12"
                          >
                            <b
                              >{#if d.discount}
                                {format(
                                  "Rp#.##0,",
                                  d.price - (d.price * d.discount) / 100
                                )}
                                <span class="text-xs text-gray-600"
                                  >discount {d.discount}%</span
                                >{:else}{format("Rp#.##0,", d.price)}{/if}</b
                            ><br />
                            <span class="text-xs"
                              >Topup {format("#.##0,", d.amount)} Point</span
                            >
                          </div>
                          <div
                            class="items-center justify-end w-1/5 lg:w-1/12 md:1/12"
                          >
                            <input
                              type="radio"
                              name="topup"
                              class="form form-radio"
                              id="topup-{i}"
                              value={d.amount}
                              on:click={() => (amount = d.amount)}
                            />
                          </div>
                        </div>
                      </label>
                    {/each}
                  {/if}
                </div>
                {#if amount > 0}
                  <button
                    on:click={() => handleSubmit()}
                    type="button"
                    class="w-full px-5 py-2 text-center text-gray-100 bg-gray-700 rounded-lg cursor-pointer text-1xl active:bg-gray-500 focus:outline-none"
                    >ORDER NOW</button
                  >
                {/if}
              </div>

              <div
                class="w-full px-2 pt-5 pb-10 my-5 bg-white rounded-lg shadow-lg"
              >
                <!--TABLE SECTION-->
                {#if loadTable}
                  <MakeSortable
                    data={dataFiltered}
                    let:table
                    {filter}
                    filterFields={["created", "updated", "amount", "type"]}
                    sortIconCss={imgsortIconCss}
                    sortIconAscCss={imgsortIconAscCss}
                    sortIconDescCss={imgsortIconDescCss}
                  >
                    <div
                      class="flex flex-wrap items-center justify-between w-full pr-2 mb-2"
                    >
                      <div
                        class="flex items-center w-1/2 gap-4 px-2 py-1 text-xs justify-tsrt lg:w-4/12 md:w-2/6"
                      >
                        <span>Total : <b>{table.rows.length}</b></span><span
                          >Filtered : <b>{table.sortedAndFilteredRows.length}</b
                          ></span
                        >
                      </div>
                      <input
                        type="text"
                        class="w-full gap-2 px-2 py-1 text-sm font-bold bg-white border border-gray-200 rounded-md shadow pointer-events-auto lg:w-4/12 md:w-2/6 focus:outline-none md:focus:border-gray-600"
                        placeholder="Search..."
                        bind:value={filter}
                      />
                    </div>

                    <div class="w-full">
                      <div
                        transition:fade
                        class="sticky z-10 w-full mb-5 bg-gray-100 border-b-4 border-gray-400 rounded-lg shadow-lg lg:shadow-lg md:shadow-lg lg:top-20 md:top-20 top-16"
                      >
                        <div
                          class="flex flex-no-wrap items-end justify-start w-full overflow-x-auto cursor-pointer lg:items-center md:items-end"
                        >
                          <SortHeader
                            css="w-52 p-2 text-sm font-bold italic"
                            path={(row) => String(row.created)}>Date</SortHeader
                          >
                          <SortHeader
                            css="w-32 p-2 text-sm font-bold italic"
                            path={(row) => parseFloat(row.amount)}
                            >Amount</SortHeader
                          >
                          <SortHeader
                            css="w-32 p-2 text-sm font-bold italic"
                            path={(row) => String(row.type)}>Status</SortHeader
                          >
                          <SortHeader
                            css="w-52 p-2 text-sm font-bold italic"
                            path={(row) => String(row.updated)}
                            >Updated</SortHeader
                          >
                          <SortHeader
                            css="w-32 p-2 text-sm font-bold italic"
                            path={(row) => String(row.type)}>Action</SortHeader
                          >
                        </div>
                      </div>

                      <div class="w-full">
                        {#if table.pageRows.length > 0}
                          {#each table.pageRows as d}
                            <div
                              class="w-full mx-0 my-2 overflow-hidden rounded-lg shadow-md lg:my-1 md:my-1 hover:bg-gray-100"
                            >
                              <label
                                for="select-{d.id}"
                                class="flex flex-wrap items-center justify-start w-full"
                              >
                                <div class="p-2 text-sm w-52">
                                  <div
                                    class="block font-mono text-xs italic lg:hidden md:block"
                                  >
                                    Date
                                  </div>
                                  {#if d.created}
                                    {String(d.created)}
                                  {:else}
                                    -
                                  {/if}
                                </div>
                                <div class="w-32 p-2 text-sm">
                                  <div
                                    class="block font-mono text-xs italic lg:hidden md:block"
                                  >
                                    Amount
                                  </div>
                                  {#if d.amount}
                                    {String(format("#.##0,", d.amount))}
                                  {:else}
                                    -
                                  {/if}
                                </div>
                                <div class="w-32 p-2 text-sm">
                                  <div
                                    class="block font-mono text-xs italic lg:hidden md:block"
                                  >
                                    Status
                                  </div>
                                  {#if d.type}
                                    {String(d.type)}
                                  {:else}
                                    -
                                  {/if}
                                </div>
                                <div class="p-2 text-sm w-52">
                                  <div
                                    class="block font-mono text-xs italic lg:hidden md:block"
                                  >
                                    Updated
                                  </div>
                                  {#if d.updated}
                                    {String(d.updated)}
                                  {:else}
                                    -
                                  {/if}
                                </div>
                                <div class="w-32 p-2 text-sm">
                                  <div
                                    class="block font-mono text-xs italic lg:hidden md:block"
                                  >
                                    Action
                                  </div>
                                  {#if d.type == "topup"}
                                    <Modal backdropClose size="lg:w-4/6 w-full">
                                      <div
                                        class="sticky bottom-0 lg:block md:sticky"
                                        slot="trigger"
                                        let:open
                                      >
                                        <span
                                          on:click={open}
                                          class="px-2 py-1 text-xs text-white bg-blue-500 rounded-md cursor-pointer"
                                          >Pay Now</span
                                        >
                                      </div>
                                      <div slot="header" class="text-center">
                                        <h1 class="text-lg">
                                          Payment Channels
                                        </h1>
                                      </div>
                                      <div
                                        slot="content"
                                        class="h-auto"
                                        style="max-height:100%"
                                      >
                                        <div class="p-5 text-center">
                                          Make a payment of
                                          <h3
                                            class="p-2 text-xl font-bold text-blue-600 border border-blue-600 rounded-lg"
                                          >
                                            {String(
                                              format("Rp#.##0,", d.amount)
                                            )}
                                          </h3>
                                           to one of the channels below
                                        </div>
                                        <div
                                          class="flex flex-wrap h-auto pb-10"
                                        >
                                          {#if payMethod}
                                            {#each payMethod as d, i}
                                              <div
                                                for="topup-{i}"
                                                class="w-full lg:w-1/2 md:w-1/2"
                                              >
                                                <div
                                                  class="flex items-center justify-between px-4 py-3 m-2 text-left bg-white border border-gray-200 rounded-md hover:shadow-lg cursor-pointershadow-sm"
                                                >
                                                  <div
                                                    class="w-4/5 text-base text-gray-800 lg:w-11/12 md:w-11/12"
                                                  >
                                                    <span class="text-sm"
                                                      >{d.type}</span
                                                    ><br />
                                                    <b class="text-sm"
                                                      >{d.name}</b
                                                    ><br />
                                                    <span
                                                      class="w-full p-2 font-mono text-xl font-bold border-none rounded-md select-all"
                                                      >{d.number}</span
                                                    ><br />
                                                    <span class="text-sm"
                                                      >{d.note}</span
                                                    ><br />
                                                    <span class="text-xs"
                                                      >{d.instruction}</span
                                                    >
                                                  </div>
                                                  <div
                                                    class="items-center justify-end w-1/5 lg:w-1/12 md:1/12"
                                                  />
                                                </div>
                                              </div>
                                            {:else}
                                              <p
                                                class="p-5 mx-5 mt-10 text-center bg-yellow-100 border-2 border-yellow-200 rounded-lg"
                                              >
                                                <b class="text-2xl"
                                                  >Oops...<br />Belum ada
                                                  channel pembayaran untuk saat
                                                  ini</b
                                                ><br />Mohon maaf, channel
                                                pembayaran saat ini sedang
                                                dinonaktifkan, silahkan coba
                                                lagi nanti
                                              </p>
                                            {/each}
                                          {/if}
                                        </div>
                                      </div>
                                    </Modal>
                                  {:else}
                                    <span
                                      class="px-2 py-1 text-xs text-white bg-gray-500 rounded-md cursor-pointer"
                                      >Done</span
                                    >
                                  {/if}
                                </div>
                              </label>
                            </div>
                          {/each}
                        {:else}
                          {#if filter}
                            <div
                              class="flex items-center justify-center w-full h-full"
                            >
                              <div class="text-center">
                                <span
                                  class="italic text-gray-900 animate-pulse text-md"
                                  >Data Not Found</span
                                >
                              </div>
                            </div>
                          {:else}
                            <div
                              class="flex items-center justify-center w-full h-full"
                            >
                              <div class="text-center">
                                <span
                                  class="italic text-gray-900 animate-pulse text-md"
                                  >Data Not Found</span
                                >
                              </div>
                            </div>
                          {/if}

                          <div
                            class="flex items-center justify-center w-full h-full"
                          >
                            <div class="text-center">
                              <img
                                src="./assets/logo/logo_icon.svg"
                                alt="Mikhub Loading"
                                class="w-20 h-20 mx-auto animate-spin"
                                width="50"
                                height="50"
                              />
                            </div>
                          </div>
                        {/if}
                      </div>
                    </div>
                    <div
                      class="flex flex-no-wrap items-center justify-center w-full my-5 rounded-lg"
                    >
                      <div
                        class="flex items-center justify-center w-10 h-10 bg-white rounded-l-lg shadow"
                        class:bg-gray-300={table.paging.currentPage === 0}
                      >
                        <button
                          class="w-full h-full focus:outline-none"
                          on:click={table.paging.onPrevious}>&laquo;</button
                        >
                      </div>
                      {#each table.paging.buttons as btn (btn)}
                        <div
                          class="flex items-center justify-center w-10 h-10 bg-white shadow"
                          class:bg-gray-300={btn.active}
                        >
                          <button
                            class="w-full h-full focus:outline-none"
                            on:click={btn.onClick}>{btn.label}</button
                          >
                        </div>
                      {/each}
                      <div
                        class="flex items-center justify-center w-10 h-10 bg-white rounded-r-lg shadow"
                        class:bg-gray-300={table.paging.currentPage >=
                          table.paging.pageCount - 1}
                      >
                        <button
                          class="w-full h-full focus:outline-none"
                          on:click={table.paging.onNext}>&raquo;</button
                        >
                      </div>
                    </div>
                  </MakeSortable>
                {:else}
                  <div class="flex items-center justify-center w-full h-full">
                    <div class="text-center">
                      <img
                        src="./assets/logo/logo_icon.svg"
                        alt="Mikhub Loading"
                        class="w-20 h-20 mx-auto animate-spin"
                        width="50"
                        height="50"
                      />
                      <span class="italic text-gray-900 animate-pulse text-md"
                        >loading</span
                      >
                    </div>
                  </div>
                {/if}
                <!--/TABLE SECTION-->
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</main>
